window.onload = function() {

  if(jQuery('.section__mainbanner_support .row__mainbanner_support .col__left_mainbannersupport.influencersbox .globo-formbuilder .globo-form-app.boxed-layout form .block-container>.globo-form-control.layout-1-column:nth-child(1) input[type="text"]').length == 1)
  {
      jQuery('.section__mainbanner_support .row__mainbanner_support .col__left_mainbannersupport.influencersbox .globo-formbuilder .globo-form-app.boxed-layout form .block-container>.globo-form-control.layout-1-column:nth-child(1) input[type="text"]').val('Ambassador');
  }

  if(jQuery('.section__mainbanner_support .row__mainbanner_support .col__left_mainbannersupport.affiliatebox .globo-formbuilder .globo-form-app.boxed-layout form .block-container>.globo-form-control.layout-1-column:nth-child(1) input[type="text"]').length == 1)
  {
      jQuery('.section__mainbanner_support .row__mainbanner_support .col__left_mainbannersupport.affiliatebox .globo-formbuilder .globo-form-app.boxed-layout form .block-container>.globo-form-control.layout-1-column:nth-child(1) input[type="text"]').val('Affiliate');
  }

  if(jQuery('.section__mainbanner_support .row__mainbanner_support .col__left_mainbannersupport.wholesalesbox .globo-formbuilder .globo-form-app.boxed-layout form .block-container>.globo-form-control.layout-1-column:nth-child(1) input[type="text"]').length == 1)
  {
      jQuery('.section__mainbanner_support .row__mainbanner_support .col__left_mainbannersupport.wholesalesbox .globo-formbuilder .globo-form-app.boxed-layout form .block-container>.globo-form-control.layout-1-column:nth-child(1) input[type="text"]').val('Partners');
  }
  
}

jQuery(document).ready(function(){

    jQuery('ul.orders__list > li:nth-child(4) a').click(function(){

      jQuery('.box__modal.freeshipping__modal').addClass('active');
      
    })
    
    jQuery('ul.inquiries__list > li:last-child a').click(function(){
      
        jQuery('.box__modal.media__modal').addClass('active');
      
    })
  
	jQuery('.contain__prod_addtocart > a').click(function(){

        jQuery('.addtocart__hidden form button[type="submit"]').click()

    })

    jQuery('.box__modal .contain__infomodal i.btn__close').click(function(){

        jQuery(this).parents().find('.box__modal').removeClass('active');
      
    })
  
	jQuery('.contain__prod_addtocart>.box__field_optional i.checkbox').click(function(){

        jQuery(this).toggleClass('checked')
        
        let prodvalue = jQuery(this).attr('rel');
      
      	if(jQuery(this).hasClass('checked'))
        {            
            let nroitems = jQuery('input[type="hidden"].item__prod').length;
          
          	let newitem  = '<div class="box__itemaddtocart" rel="'+prodvalue+'">';
                newitem += 		'<input type="hidden" name="items[0][quantity]" value="1" class="item__prod_quantity">';
          		newitem += 		'<input type="hidden" name="items[0][id]" value="'+prodvalue+'" class="item__prod_id">';
          		newitem += '</div>';
          
          	jQuery('.group__prod_items').append(newitem);

            console.log('added');
        }
      	else
        {
        	jQuery('.box__itemaddtocart[rel="'+prodvalue+'"]').remove();
          console.log('remove');
        }
      
      	jQuery.each(jQuery('.box__itemaddtocart'),function(i){

            jQuery(this).find('.item__prod_id').attr('name','items['+i+'][id]')
            jQuery(this).find('.item__prod_quantity').attr('name','items['+i+'][quantity]')

        })

    })
  
	jQuery('.contain__faq_info li').click(function(){

        jQuery(this).toggleClass('open')
    })
    
    jQuery('.contain__prod_addtocart > .box__field select.package').change(function(){

        jQuery('.product-form__input--quantity').val(jQuery(this).val())
    })
    
    jQuery('.contain__prod_addtocart > .box__field select.productlist').change(function(){

        location.href = location.origin+jQuery(this).val();
    })
    
    jQuery('.section__mainbanner_faq .row__mainbannerfaq .tabs__faq_list li').click(function(){

        jQuery('.section__mainbanner_faq .row__mainbannerfaq .tabs__faq_list li.active').not(jQuery(this)).removeClass('active');
        jQuery(this).addClass('active');
      
      	let relation = jQuery(this).attr('rel')
      
      	jQuery('.section__mainbanner_faq .row__mainbannerfaq .contain__faq_info[rel].active').not(jQuery('.section__mainbanner_faq .row__mainbannerfaq .contain__faq_info[rel="'+relation+'"]')).removeClass('active');
        jQuery('.section__mainbanner_faq .row__mainbannerfaq .contain__faq_info[rel="'+relation+'"]').addClass('active');
    
	})
  
  	jQuery('.section__reviews .row__reviews ul').slick({
      infinite : true,
      slidesToShow: 3,
      slidesToScroll: 1,     
      adaptiveHeight: true,
      responsive: [ 
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true
                      }
                    },
        			{
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true
                      }
                    }
  				  ]
    });

  jQuery('.box_whatisfulvicacid ul').slick({
      infinite : true,
      slidesToShow: 4,
      slidesToScroll: 1,    
    arrow:true,
    adaptiveHeight: true,
      responsive: [ 
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true
                      }
                    },
        			{
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true
                      }
                    }
  				  ]
    });
  
  	jQuery('footer .col__footer h1').click(function(){
      
        jQuery(this).parent().find('ul').toggleClass('active');
      
    })

  jQuery('.section__ourbestdeals .row__ourbestdeals ul li a').click(function(){

    jQuery(this).parent().find('form button[type="submit"]').click()
    
  })

jQuery('.radio-box-selection').on('click', function(e){
  jQuery('.radio-box-selection').removeClass('selected');
  jQuery(this).addClass('selected');
  $('#one-bottle-product-var').val( $(this).data('product-variant-id') )
})
  
})